export const CALENDLY_URL = 'https://calendly.com/contact-flurrysystems/clock-earnings-demo';
